import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSyllabusThunk,
  parseSyllabusExcel,
  submitSyllabusThunk,
  getSyllabusScheduleThunk
} from "./syllabusthunk";

const syllabusSlice = createSlice({
  name: "syllabus",
  initialState: {
    syllabus: [],
    syllabusData: [],
    tableData: [],
    syllabusSchedule: [],
    loading: false,
    error: null,
  },
  reducers: {
    handleTableData(state, action) {
      const { id, name, value } = action.payload;
      state.tableData = state.tableData.map((data) =>
        data.id === id ? { ...data, [name]: value } : { ...data }
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(parseSyllabusExcel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(parseSyllabusExcel.fulfilled, (state, action) => {
        state.loading = false;
        state.syllabus = action.payload.convertedData;
        state.tableData = action.payload.tableData;
      })
      .addCase(parseSyllabusExcel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(submitSyllabusThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitSyllabusThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(submitSyllabusThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getSyllabusThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSyllabusThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.syllabusData = action.payload;
      })
      .addCase(getSyllabusThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getSyllabusScheduleThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSyllabusScheduleThunk.fulfilled, (state, action) => {
        state.loading = false;
        // API may return either an array directly or an object containing `data`
        state.syllabusSchedule = action.payload?.data ?? action.payload;
      })
      .addCase(getSyllabusScheduleThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { handleTableData } = syllabusSlice.actions;
export default syllabusSlice.reducer;
